import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigate, useLocation } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import Profile from "./pages/Profile/Profile";

import HomePageVitrine from "./pages/Home/Home";
import LoginPage from "./pages/LoginPage/LoginPage";
import RegisterPage from "./pages/RegisterPage/RegisterPage";

import ResetPwd from "./pages/ResetPwd/ResetPwd";
import ForgotPasswordPage from "./pages/ResetPwd/ForgotPasswordPage";
import { UserProvider } from "./pages/Home/UserContext";
import PrimaryColorProvider from "./hooks/PrimaryColorProvider.jsx";

import DashboardUsers from "./pages/PagesUtilisateurs/DashboardUsers/DashboardUsers";

import Navbar2 from "./pages/Home/Navbar2/Navbar2";
import Footer from "./pages/Home/Footer";

import { NotificationProvider } from "./hooks/NotificationContext";
import { MessageProvider } from "./hooks/MessageContext.js";
import { ContactFormProvider } from "./hooks/ContactFormContext.js";

import ErrorPage from "./pages/ErrorPage/ErrorPage";

// PageVisiteurs
import PartenaireDetail from "./pages/Partenaires/PartenaireDetail";
import TousLesPartenaires from "./pages/Partenaires/TousLesPartenaires";
import PagePersonnalisee from "./pages/PagePersonnalisee/PagePersonnalisee.jsx";
import Tutoriel from "./pages/Tutoriel/Tutoriel.jsx";


// Documents
import ReglementInterieur from "./pages/Documents/ReglementInterieur";
import ConditionsUtilisationPage from "./pages/rgpd/ConditionsUtilisationPage.jsx";
import PolitiqueConfidentialitePage from "./pages/rgpd/PolitiqueConfidentialitePage.jsx";
import FaqPage from "./pages/rgpd/FaqPage.jsx";
import MentionsLegalesPage from "./pages/rgpd/MentionsLegalesPage.jsx";

// PagesUtilisateurs
import InscriptionPage from "./pages/PagesUtilisateurs/InscriptionPage/InscriptionPage";
import InscriptionAdherent from "./pages/PagesUtilisateurs/InscriptionAdherent/InscriptionAdherent";
import AttestationPage from "./pages/PagesUtilisateurs/InscriptionAdherent/AttestationPage";
import FicheAdherent from "./pages/PagesUtilisateurs/FicheAdherent/FicheAdherent";
import TechniquesView from "./pages/PagesUtilisateurs/TechniquesView/TechniquesView.jsx";
import TechniquesQuizz from "./pages/PagesUtilisateurs/TechniquesQuizz/TechniquesQuizz.jsx";
import Messaging from "./pages/PagesUtilisateurs/Messaging/Messaging.js";
import LexiquePage from "./pages/PagesUtilisateurs/LexiquePage/LexiquePage.jsx";
import ListEvents from "./pages/PagesUtilisateurs/ListEvents/ListEvents";
import NewsPage from "./pages/PagesUtilisateurs/NewsPage/NewsPage";
import Boutique from "./pages/PagesUtilisateurs/Boutique/Boutique";
import GalleriesPhotos from "./pages/PagesUtilisateurs/GalleriesPhotos/GalleriesPhotos";
import AlbumGaleriePage from "./pages/PagesUtilisateurs/GalleriesPhotos/AlbumGaleriePage";
import UsersReglements from "./pages/PagesUtilisateurs/UsersReglements/UsersReglements";
import ChatPage from "./pages/PagesUtilisateurs/ChatPage/ChatPage";
import CheckoutForm from "./pages/PagesUtilisateurs/UsersReglements/CheckoutForm";
import PaymentSuccess from "./pages/PagesUtilisateurs/UsersReglements/PaymentSuccess";
import DiplomePage from "./pages/PagesUtilisateurs/FicheAdherent/DiplomePage";
import ArbitrageJudo from "./pages/PagesUtilisateurs/Arbitrage/ArbitrageJudo";
import JudoScorePage from "./pages/JudoScorePage/JudoScorePage";
import ProduitsApp from "./pages/PagesUtilisateurs/ProduitsApp/ProduitsApp.jsx";
import AbsencesPage from "./pages/PagesUtilisateurs/AbsencesPage/AbsencesPage.jsx";
import UserVotePage from "./pages/PagesUtilisateurs/UserVotePage/UserVotePage.jsx";
import PrepaPhysique from "./pages/PagesUtilisateurs/PrepaPhysique/PrepaPhysique.jsx";
import HighLevelAdherentSessionsPage from "./pages/PagesUtilisateurs/HighLevel/HighLevelAdherentSessionsPage.jsx";

// PagesEnseignants
import ListingAdherents from "./pages/PagesEnseignants/ListingAdherents/ListingAdherents";
import AttendancePage from "./pages/PagesEnseignants/AttendancePage/AttendancePage";
import EventsPage from "./pages/PagesEnseignants/EventsPage/EventsPage.jsx";
import SuiviCompetitions from "./pages/PagesEnseignants/Competitors/SuiviCompetitions.jsx";
import PassageCeintureGrid from "./pages/PagesEnseignants/PassageCeinture/PassageCeintureGrid.jsx";
import GradeCNPage from "./pages/PagesEnseignants/GradeCNPage/GradeCNPage.js";
import PalmaresPage from "./pages/PagesEnseignants/PalmaresPage/PalmaresPage.jsx";
import ToDoListPage from "./pages/PagesEnseignants/ToDoListPage/ToDoListPage.jsx";
import AttendanceTable from "./pages/PagesEnseignants/AttendanceTable/AttendanceTable.jsx";
import CategoriesPage from "./pages/PagesEnseignants/CategoriesPage/CategoriesPage.jsx";
import PrepaPhysiqueCoaching from "./pages/PagesEnseignants/PrepaPhysiqueCoaching/PrepaPhysiqueCoaching.jsx";
import AideTutoEnseignants from "./pages/PagesEnseignants/AideTutoEnseignants/AideTutoEnseignants.jsx";
import TechniquesPages from "./pages/PagesEnseignants/TechniquesPages/TechniquesPages.jsx";
import ObjectifsAdmin from "./pages/PagesEnseignants/ObjectifsAdmin/ObjectifsAdmin.jsx";
import HighLevelSessionsPage from "./pages/PagesEnseignants/HighLevelSessions/HighLevelSessionsPage.jsx";

// PagesAdministrateurs
import UserListing from "./pages/PagesAdministrateurs/UserListing/UserListing";
import Dashboard from "./pages/PagesAdministrateurs/Dashboard/Dashboard";
import DashboardCompta from "./pages/PagesAdministrateurs/DashboardCompta/DashboardCompta";
import DossierInscriptionPage from "./pages/PagesAdministrateurs/DossierInscriptionPage/DossierInscriptionPage";
import Achats from "./pages/PagesAdministrateurs/Achats/Achats";
import ReglementInscriptionPage from "./pages/PagesAdministrateurs/ReglementInscription/ReglementInscriptionPage";
import Coaching from "./pages/PagesAdministrateurs/Coaching/Coaching.jsx";
import SettingsPage from "./pages/PagesAdministrateurs/SettingsPage/SettingsPage.jsx";
import ListingAdherentsAdmin from "./pages/PagesAdministrateurs/ListingAdherentsAdmin/ListingAdherentsAdmin.jsx";
import ChatPageAdmin from "./pages/PagesAdministrateurs/ChatPageAdmin/ChatPageAdmin.jsx";
import MessageAdmin from "./pages/PagesAdministrateurs/MessageAdmin/MessageAdmin.jsx";
import HeuresEnseignement from "./pages/PagesAdministrateurs/HeuresEnseignement/HeuresEnseignement.jsx";
import InventairePage from "./pages/PagesAdministrateurs/InventairePage/InventairePage.jsx";
import DepensesRecettes from "./pages/PagesAdministrateurs/DepensesRecettes/DepensesRecettes.jsx";
import DetailsAdherent from "./pages/PagesAdministrateurs/DetailsAdherent/DetailsAdherent.jsx";
import ArticlesAdmin from "./pages/PagesAdministrateurs/ArticlesAdmin/ArticlesAdmin.jsx";
import RequestsAdmin from "./pages/PagesAdministrateurs/RequestsAdmin/RequestsAdmin.jsx";
import AbonnementPage from "./pages/PagesAdministrateurs/AbonnementPage/AbonnementPage.jsx";
import UpdatePage from "./pages/PagesAdministrateurs/UpdatePage/UpdatePage.jsx";
import VotePage from "./pages/PagesAdministrateurs/VotePage/VotePage.jsx";
import AideConseilsAdmin from "./pages/PagesAdministrateurs/AideConseils/AideConseilsAdmin.jsx";
import PagesPersonnalisees from "./pages/PagesAdministrateurs/PagesPersonnalisees/PagesPersonnalisees.jsx";
import AdherentPretPage from "./pages/PagesAdministrateurs/AdherentPretPage/AdherentPretPage.jsx";

// DashboardAdmin
// import DashboardLayout from "./pages/PagesAdministrateurs/DashboardAdmin/DashboardLayout.jsx";

// ... importez d'autres pages si nécessaire
import "./App.css";
import "./bulma.min.css";

const stripePromise = loadStripe(
  "pk_test_51POgHVEr14Icaey6JeVMxJf9bAJS9AxDAGUTSDI80b01LVDorrxErNHC1HbTU3WRgJfPD3P40daULyEzeakVDBfk00fHPS7sVp"
);

const App = () => {
  // Gestion des states
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const getLocalStorageItem = (key) => {
      try {
        console.log("Tentative de lecture du localStorage pour la clé:", key);
        const item = localStorage.getItem(key);
        console.log("Valeur obtenue:", item);
        return item ? JSON.parse(item) : null;
      } catch (error) {
        console.error(
          "Erreur lors de la lecture du localStorage pour la clé",
          key,
          ":",
          error
        );
        return null;
      }
    };

    const storedUserInfo = getLocalStorageItem("userInfo");
    if (storedUserInfo) {
      setUserInfo(storedUserInfo);
    } else {
      console.error(
        "Les informations de l'utilisateur stockées sont introuvables ou corrompues."
      );
      // Actions supplémentaires ici, comme une redirection ou une récupération depuis un serveur
    }
  }, []);

  const RequireAuth = ({ children, roles }) => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo")); // Assure-toi que userInfo est stocké dans localStorage
    const location = useLocation();

    if (!userInfo) {
      return <div>Chargement...</div>; // Ou un composant de chargement plus sophistiqué
    }

    if (roles && !roles.includes(userInfo.role_id)) {
      // Rôle non autorisé donc redirection vers une page d'erreur ou d'accueil
      return <Navigate to="/unauthorized" replace />;
    }

    return children;
  };

  // Pour l'exemple, nous allons simuler un utilisateur connecté
  const user = {
    id: 1,
    nom: "Doe",
    prenom: "John",
    email: "JohnDoe@gmail.com",
    photoURL: "path_to_photo.jpg", // Remplace par le chemin réel de la photo
    role_id: 1, // 1 = Administrateur
    userId: 1,
  };

  return (
    <UserProvider>
      <Router>
        <Elements stripe={stripePromise}>
          <MessageProvider>
            <NotificationProvider>
              <ContactFormProvider>
                <PrimaryColorProvider>
                  <div className="flex flex-col min-h-screen bg-base-200 dark:bg-gray-600 dark:text-gray-200">
                    <Navbar2
                      user={{
                        nom: userInfo?.nom ?? "Chargement...",
                        prenom: userInfo?.prenom ?? "",
                        role_id: userInfo?.role_id ?? 0,
                        photoURL: userInfo?.photoURL ?? "",
                        userId: userInfo?.id ?? 0,
                      }}
                    />
                    <Routes>
                      {/* Route pour la page d'accueil du site vitrine */}
                      <Route path="/" element={<HomePageVitrine />} />
                      <Route
                        path="/techniques-judo"
                        element={
                          <RequireAuth roles={[2, 3, 1, 4]}>
                            <TechniquesView />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/absences"
                        element={
                          <RequireAuth roles={[2, 3, 1]}>
                            <AbsencesPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/pret-materiel"
                        element={
                          <RequireAuth roles={[1]}>
                            <AdherentPretPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/techniques-enseignants"
                        element={
                          <RequireAuth roles={[3, 1]}>
                            <TechniquesPages />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/suivi-sessions-haut-niveau"
                        element={
                          <RequireAuth roles={[3, 1]}>
                            <HighLevelSessionsPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/sessions-haut-niveau"
                        element={
                          <RequireAuth roles={[3, 2, 1]}>
                            <HighLevelAdherentSessionsPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/aide-enseignants"
                        element={
                          <RequireAuth roles={[1, 3]}>
                            <AideTutoEnseignants />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/objectifs"
                        element={
                          <RequireAuth roles={[1, 3]}>
                            <ObjectifsAdmin />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/prepa-physique"
                        element={
                          <RequireAuth roles={[2, 3, 1, 4]}>
                            <PrepaPhysique />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/prepa-physique-coaching"
                        element={
                          <RequireAuth roles={[3, 1, 4]}>
                            <PrepaPhysiqueCoaching />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/techniques-quizz"
                        element={
                          <RequireAuth roles={[2, 3, 1, 4]}>
                            <TechniquesQuizz />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/messages"
                        element={
                          <RequireAuth roles={[2, 3, 1]}>
                            <Messaging />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/commandes-&-reglements"
                        element={
                          <RequireAuth roles={[2, 3, 1]}>
                            <UsersReglements />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/tableau-de-bord"
                        element={
                          <RequireAuth roles={[2, 3, 1]}>
                            <DashboardUsers />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/boutique"
                        element={
                          <RequireAuth roles={[2, 3, 1]}>
                            <Boutique />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/chat"
                        element={
                          <RequireAuth roles={[2, 3, 1]}>
                            <ChatPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/paiements"
                        element={
                          <RequireAuth roles={[1]}>
                            <Achats />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/depenses-recettes"
                        element={
                          <RequireAuth roles={[1]}>
                            <DepensesRecettes />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/parametres"
                        element={
                          <RequireAuth roles={[1]}>
                            <SettingsPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/dossier-d-inscription"
                        element={
                          <RequireAuth roles={[2, 3, 1, 4]}>
                            <InscriptionAdherent />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/attestation"
                        element={
                          <RequireAuth roles={[2, 3, 1]}>
                            <AttestationPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/diplome-grade"
                        element={
                          <RequireAuth roles={[2, 3, 1]}>
                            <DiplomePage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/listing-utilisateurs"
                        element={
                          <RequireAuth roles={[1]}>
                            <UserListing />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/checkout"
                        element={
                          <RequireAuth roles={[1, 2, 3]}>
                            <CheckoutForm />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/reglements-inscriptions"
                        element={
                          <RequireAuth roles={[1, 2]}>
                            <ReglementInscriptionPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/dossiers-d-inscription"
                        element={
                          <RequireAuth roles={[1]}>
                            <DossierInscriptionPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/fiche-adherent"
                        element={
                          <RequireAuth roles={[2, 3, 1]}>
                            <FicheAdherent />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/calendrier"
                        element={
                          <RequireAuth roles={[2, 3, 1]}>
                            <ListEvents />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/actualites"
                        element={
                          <RequireAuth roles={[2, 3, 1]}>
                            <NewsPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/lexique"
                        element={
                          <RequireAuth roles={[2, 3, 1]}>
                            <LexiquePage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/arbitrage-judo"
                        element={
                          <RequireAuth roles={[2, 3, 1]}>
                            <ArbitrageJudo />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/judo-score"
                        element={
                          <RequireAuth roles={[2, 3, 1, 4]}>
                            <JudoScorePage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/applications-judo"
                        element={
                          <RequireAuth roles={[2, 3, 1]}>
                            <ProduitsApp />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/galerie-photos/album/:id"
                        element={
                          <RequireAuth roles={[2, 3, 1]}>
                            <AlbumGaleriePage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/galerie-photos"
                        element={
                          <RequireAuth roles={[2, 3, 1]}>
                            <GalleriesPhotos />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/listing-adherents"
                        element={
                          <RequireAuth roles={[3, 1]}>
                            <ListingAdherents />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/passage-ceinture"
                        element={
                          <RequireAuth roles={[3, 1]}>
                            <PassageCeintureGrid />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/grade-cn"
                        element={
                          <RequireAuth roles={[3, 1]}>
                            <GradeCNPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/suivi-competitions"
                        element={
                          <RequireAuth roles={[3, 1]}>
                            <SuiviCompetitions />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/palmares"
                        element={
                          <RequireAuth roles={[3, 1]}>
                            <PalmaresPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/todolist"
                        element={
                          <RequireAuth roles={[3, 1]}>
                            <ToDoListPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/coachings"
                        element={
                          <RequireAuth roles={[1]}>
                            <Coaching />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/heures-enseignement"
                        element={
                          <RequireAuth roles={[1]}>
                            <HeuresEnseignement />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/articles-admin"
                        element={
                          <RequireAuth roles={[1]}>
                            <ArticlesAdmin />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/inventaire"
                        element={
                          <RequireAuth roles={[1]}>
                            <InventairePage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/listing-adherents-admin"
                        element={
                          <RequireAuth roles={[1]}>
                            <ListingAdherentsAdmin />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/chat-page-admin"
                        element={
                          <RequireAuth roles={[1]}>
                            <ChatPageAdmin />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/message-admin"
                        element={
                          <RequireAuth roles={[1]}>
                            <MessageAdmin />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/evenements"
                        element={
                          <RequireAuth roles={[3, 1]}>
                            <EventsPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/appel-presence"
                        element={
                          <RequireAuth roles={[3, 1]}>
                            <AttendancePage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/tableau-appel"
                        element={
                          <RequireAuth roles={[3, 1]}>
                            <AttendanceTable />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/dashboard-adherents"
                        element={
                          <RequireAuth roles={[1]}>
                            <Dashboard />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/dashboard-comptabilite"
                        element={
                          <RequireAuth roles={[1]}>
                            <DashboardCompta />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/requetes-admin"
                        element={
                          <RequireAuth roles={[1]}>
                            <RequestsAdmin />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/update"
                        element={
                          <RequireAuth roles={[1]}>
                            <UpdatePage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/abonnement"
                        element={
                          <RequireAuth roles={[1]}>
                            <AbonnementPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/details-adherent"
                        element={
                          <RequireAuth roles={[1]}>
                            <DetailsAdherent />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/vote-sondage-admin"
                        element={
                          <RequireAuth roles={[1]}>
                            <VotePage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/aide-conseils"
                        element={
                          <RequireAuth roles={[1]}>
                            <AideConseilsAdmin />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/categories"
                        element={
                          <RequireAuth roles={[3, 1]}>
                            <CategoriesPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/vote-sondage-utilisateur"
                        element={
                          <RequireAuth roles={[1, 2, 3]}>
                            <UserVotePage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/ajouter-inscription-adherent"
                        element={
                          <RequireAuth roles={[2, 3, 1]}>
                            <InscriptionPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/profile"
                        element={
                          <RequireAuth roles={[2, 3, 1]}>
                            <Profile />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/pages-personnalisees"
                        element={
                          <RequireAuth roles={[2, 3, 1, 4]}>
                            <PagesPersonnalisees />
                          </RequireAuth>
                        }
                      />
                      {/* <Route
                        path="/dashboard-admin"
                        element={
                          <RequireAuth roles={[1]}>
                            <DashboardLayout />
                          </RequireAuth>
                        }
                      /> */}

                      <Route path="/login" element={<LoginPage />} />
                      <Route path="/register" element={<RegisterPage />} />
                      <Route
                        path="/reset-password/:token"
                        element={<ResetPwd />}
                      />
                      <Route
                        path="/forgot-password"
                        element={<ForgotPasswordPage />}
                      />
                      <Route path="/404" element={<ErrorPage />} />
                      <Route path="*" element={<ErrorPage />} />
                      <Route
                        path="/payment-success"
                        element={<PaymentSuccess />}
                      />
                      <Route
                        path="/reglement-interieur"
                        element={<ReglementInterieur />}
                      />
                      <Route
                        path="/conditions-utilisation"
                        element={<ConditionsUtilisationPage />}
                      />
                      <Route
                        path="/politique-confidentialite"
                        element={<PolitiqueConfidentialitePage />}
                      />
                      <Route path="/faq" element={<FaqPage />} />
                      <Route
                        path="/mentions-legales"
                        element={<MentionsLegalesPage />}
                      />
                      <Route
                        path="/partenaires/:nom"
                        element={<PartenaireDetail />}
                      />
                      <Route
                        path="/partenaires"
                        element={<TousLesPartenaires />}
                      />
                      <Route
                        path="/page/:slug"
                        element={<PagePersonnalisee />}
                      />
                      <Route path="/tutoriel" element={<Tutoriel />} />
                    </Routes>
                    <Footer />
                  </div>
                </PrimaryColorProvider>
              </ContactFormProvider>
            </NotificationProvider>
          </MessageProvider>
        </Elements>
      </Router>
    </UserProvider>
  );
};

export default App;
